// FormRecord (job page round): one form a tech filled in, or a signature, as a line that opens to its
// answers: its name, then who and when, muted ("Combustion test · Sam · Sat Oct 24, 3:30 p.m."). It
// opens with the Area's chevron (AreaChevron), never the browser's triangle, and a button that says
// whether it's open. A blank answer that matters is red in its KeyValue. Reads only --record-*.
import { useId, useState, type ReactNode } from 'react';
import { AreaChevron } from '../Area/Area.tsx';
import './FormRecord.css';

export interface FormRecordProps {
  title: string;
  /** Who filled it in and when. */
  meta?: string;
  /** Its answers: a KeyValue, a signature. */
  children: ReactNode;
  defaultOpen?: boolean;
}

export function FormRecord({ title, meta, children, defaultOpen = false }: FormRecordProps) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return (
    <div className="fl-record" data-open={open ? '' : undefined}>
      <button
        type="button"
        className="fl-record__head"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(!open)}
      >
        <AreaChevron open={open} />
        <span className="fl-record__title">{title}</span>
        {meta ? <span className="fl-record__meta">· {meta}</span> : null}
      </button>
      <div id={id} className="fl-record__body" hidden={!open}>
        {children}
      </div>
    </div>
  );
}
